import {
  DateRangePresetDays30,
  getDefaultCustomDateRange,
  type DateRangeValue,
} from '../../../utils/dateHelpers';

interface DsnFilterDefaults {
  selectedStatus: string | null;
  selectedNatures: string[];
  selectedUserIds: string[] | null;
  isTest: boolean;
  searchValue: string;
  dateRangeValue: DateRangeValue;
}

export const INITIAL_DSN_FILTERS: DsnFilterDefaults = {
  selectedStatus: null,
  selectedNatures: [],
  selectedUserIds: null,
  isTest: true,
  searchValue: '',
  dateRangeValue: { preset: DateRangePresetDays30 },
};

export const INITIAL_DATES = getDefaultCustomDateRange();

export const INITIAL_QUERY_PARAMS = {
  top: 50,
  count: true,
  isTest: true,
  isDate: true,
  isUser: false,
  expand: ['DsnTiersDeclareObj'],
};

export const INITIAL_PAGINATION = {
  pageSize: 20,
  currentPage: 1,
  totalCount: 0,
};
